// extracted by mini-css-extract-plugin
export default {"main":"main-layout_main__o+1ef","content":"main-layout_content__g-iuf"};